import * as React from 'react';
import { playerApi } from '../../../adapters/APIExporter';
import { NflNews } from '../../../sdk/model';
import { Box, Link } from '@mui/material';

interface playerNewsProps {
  playerId: string
}

export default function PlayerNewsComponent(props: playerNewsProps) {
  const [loading, setLoading] = React.useState(true);
  const [news, setNews] = React.useState<NflNews[]>([]);
  const [error, setError] = React.useState(false);
  
  React.useEffect(() => {
    playerApi.getPlayerNews(props.playerId).then(response => {
      setNews(response.data)
    }).catch(error => {
      console.log(error)
      setError(true)
    }).finally(() => {
      setLoading(false)
    })
  }, []);
  
  if (loading) {
    return <p>Loading Player News...</p>
  }
  
  if (error) {
    return <p className='error'>Error loading player news</p>
  }
  
  return <Box>
    {news.map((item, itemIndex) => 
      <p><Link key={itemIndex} href={item.link} target="_blank">{item.title} <img src={item.image} alt={item.title} style={{height: '50px'}} /></Link></p>
      
    )}
  </Box>
}